module.exports = __webpack_public_path__ + "static/img/cpwx.c8c1ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cpwx.png
// module id = amc+
// module chunks = 4